import Vue from "vue";
import Vuex from "vuex";
import auth from "@/store/modules/auth";
import busy from "@/store/modules/busy";
import config from "@/store/modules/config";
import missions from "@/store/modules/missions";
import filters from "@/store/modules/filters";
import contracts from "@/store/modules/contracts";

Vue.use(Vuex);

const state = {
  snackbar: {
    active: false,
    text: "",
    color: "teal",
    timeout: 2000,
  },
  loading: false,
  environment: process.env.NODE_ENV,
};

const mutations = {
  snacktime(state, data) {
    if (data.color === "error") data.color = "red darken-3";

    state.snackbar.text = data.text;
    state.snackbar.color = data.color || "teal";
    state.snackbar.timeout = data.timeout || state.snackbar.timeout;
    state.snackbar.active = true;
  },
  startLoading(state) {
    state.loading = true;
  },
  endLoading(state) {
    state.loading = false;
  },
};

const modules = {
  auth,
  config,
  filters,
  missions,
  contracts,
  "Busy": busy, // Justification: uppercase for modules so $store.state.foo won't accidentally reference a Foo module
}

export default new Vuex.Store({
  state,
  mutations,
  modules,
});
